import React, { memo } from "react";
import { Result } from "antd";

export default memo(function NoFoundPage({
  title = "Error",
  subTitle = "Something went wrong",
}) {
  return <Result status="error" title={title} subTitle={subTitle} />;
});
